export default "__VITE_ASSET__15e04a4e__"